import { FormControl, MenuItem, Select, Typography } from '@mui/material'
import { GRAPHQL_QUERY_POLICY, PAGE_LIMIT, QUERY_PARAMS } from '../../constants'
import { useEffect, useState } from 'react'
import { ReferralSource, useFetchAllReferralSourcesLazyQuery } from '../../../generated'
import { StyledInputLabel } from '../../theme/styleComponents'
import { useSearchParams } from 'react-router-dom'
import { anchorOrigin, transformOrigin } from '../../theme/styleConstants'

const ReferralTypeDropdown = () => {
  const [referralSources, setReferralSources] = useState<ReferralSource[]>([])
  const [searchParams, setSearchParams] = useSearchParams()

  const [fetchAllReferralSources] = useFetchAllReferralSourcesLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onCompleted(data) {
      const { referralSources } = data.fetchAllReferralSources
      setReferralSources(referralSources as ReferralSource[])
    },
    onError(error) {
      console.error('Error fetching referral sources', error)
      setReferralSources([])
    }
  })

  useEffect(() => {
    fetchAllReferralSources({
      variables: {
        fetchAllSources: {
          paginationOptions: {
            limit: PAGE_LIMIT,
            page: 1
          }
        }
      }
    })
  }, [fetchAllReferralSources])

  const getFilterValues = (key: QUERY_PARAMS) => String(searchParams.get(key) || QUERY_PARAMS.ALL)

  const setParams = (key: QUERY_PARAMS, value: string) => {
    const newParams = new URLSearchParams(searchParams.toString())

    switch (key) {
      case QUERY_PARAMS.SOURCE_TYPE:
        newParams.set(key, value)
        break
      default:
        newParams.delete(QUERY_PARAMS.SOURCE_TYPE)
        break
    }
    setSearchParams(newParams)
  }
  return (
    <FormControl>
      <StyledInputLabel id="source-label">Type</StyledInputLabel>

      <Select
        labelId={'source-label'}
        label="Type"
        onChange={event => setParams(QUERY_PARAMS.SOURCE_TYPE, String(event.target.value))}
        value={getFilterValues(QUERY_PARAMS.SOURCE_TYPE)}
        sx={{ width: '100%', minWidth: '100px' }}
        MenuProps={{ anchorOrigin, transformOrigin }}
      >
        <MenuItem value="all">All</MenuItem>
        {referralSources.map(source => (
          <MenuItem value={String(source.id)} key={source.id}>
            <Typography variant="body1">{source.sourceType}</Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default ReferralTypeDropdown
